module.exports = __webpack_public_path__ + "static/bg-fe96d35d31e4a9f1718184dda955a84f.mp4";